import { Routes } from '@angular/router';

export const JobRoutes: Routes = [];
